import { ToastState } from './types'

export const initialToastState: ToastState = {
	toasts: [],
	timeout: 5000
}
